import React, { useState } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import { criarAgentesRecebedoresDs } from "../../DataSources";
import { LoadIndicator } from "devextreme-react/load-indicator";
import apiAxios from "../../api-reports";
import notify from "devextreme/ui/notify";
import showError from "../../AppServices";

const ArrecadacaoReceita = () => {
  const [estado, setEstado] = useState({
    id: undefined,
    dataInicial: undefined,
    dataFinal: undefined,
    agenteRecebedorId: undefined,
    tipoBaixa: "T",
  });

  const [botao, setBotao] = useState({
    loadIndicatorVisivel: false,
    texto: "Visualizar PDF",
  });

  const agenteRecebedorOptions = {
    editorType: "dxSelectBox",
    dataSource: criarAgentesRecebedoresDs(),
    valueExpr: "id",
    displayExpr: "descricao",
    searchMode: "contains",
  };

  const tipoDeBaixaOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: "T", descricao: "Todos" },
      { id: "M", descricao: "Manual" },
      { id: "A", descricao: "Automática" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  function ok() {
    const request = { ...estado, prefeituraId: UserInfo.getPrefeitura() };
    apiAxios
      .post("/report/arrecadacao_receita", {
        ...request,
        responseType: "blob",
      })
      .then((response) => {
        if (response.data.sucesso) {
          const bin = atob(response.data.report);
          const length = bin.length;
          const arrayBuffer = new ArrayBuffer(length);
          const uintArray = new Uint8Array(arrayBuffer);

          for (let i = 0; i < length; i++) {
            uintArray[i] = bin.charCodeAt(i);
          }

          const fileBlob = new Blob([uintArray], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(fileBlob);

          window.open(fileURL, "_blank");
          return true;
        } else {
          notify("Relatório não encontrado.", "error");
          showError(response.data.erros);
          return false;
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      })
      .finally(() => {
        setBotao({
          loadIndicatorVisivel: false,
          texto: "Visualizar PDF",
        });
      });
  }

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={estado} colCount={2}>
          <GroupItem
            caption="Relatório de Arrecadação por Receita"
            colSpan={2}
            colCount={4}
          >
            <SimpleItem
              dataField={"dataInicial"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%" , useMaskBehavior: true}}
            >
              <Label text="Data de Início" />
            </SimpleItem>

            <EmptyItem colSpan={3} />

            <SimpleItem
              dataField={"dataFinal"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data do Fim" />
            </SimpleItem>
            <EmptyItem colSpan={3} />
            <SimpleItem
              dataField={"agenteRecebedorId"}
              editorType={"dxSelectBox"}
              editorOptions={agenteRecebedorOptions}
              colSpan={4}
            >
              <Label text="Agente Recebedor" />
            </SimpleItem>
            <SimpleItem
              dataField={"tipoBaixa"}
              editorType={"dxSelectBox"}
              editorOptions={tipoDeBaixaOptions}
            >
              <Label text="Tipo de Baixa" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <Button
              width={120}
              style={{ display: "inline-block", justifyContent: "center" }}
              type="success"
              onClick={() => ok()}
            >
              <LoadIndicator
                className="button-indicator"
                id="small-indicator"
                height={20}
                width={20}
                visible={botao.loadIndicatorVisivel}
                style={{ marginRight: "10px", verticalAlign: "middle" }}
              />
              <span className="dx-button-text">{botao.texto}</span>
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ArrecadacaoReceita;
